import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';

import Tooltip from 'carbon-react/lib/components/tooltip';
import Icon from 'carbon-react/lib/components/icon';

import { usePredictionsInfoContext } from '../../../../forecast/detail/context/predictions-info-context';
import { useReportBuilderContext } from '../../../report-builder.context';
import { DataField } from '../../../types';

import styles from './settings-panel.scss';

interface Props {
  field: DataField;
  onDelete: (ref: string) => void;
  showFieldMapping: (ref: string) => void;
}

export const SettingsFinPanelNeedsMapping = ({ field, onDelete, showFieldMapping }: Props) => {
  const intl = useIntl();
  const { isConsolidation } = usePredictionsInfoContext();
  const { dataReferenceMapping } = useReportBuilderContext();

  const getFieldType = (field: DataField) => {
    if (!field.classifier) {
      return intl.formatMessage({ id: 'reporting.financial_field', defaultMessage: 'financial field' });
    }
    if (field.classifier === 'assumption') {
      return intl.formatMessage({ id: 'common.prediction', defaultMessage: 'Prediction' });
    }
    if (field.classifier === 'row-formula' || field.classifier === 'template-formula') {
      return intl.formatMessage({ id: 'reporting.account_within_formula', defaultMessage: 'account within formula' });
    }
    return field.classifier.replace('-', ' ');
  };

  return (
    <div className={clsx(styles.expandPanelContainer, styles[field.classifier || 'parent'])}>
      <div className={styles.needsMappingWrapper}>
        <div className={clsx(styles.panelSummary)}>
          <div className={styles.leftSide}>
            <Icon type="drag" className={styles.dragIcon} />
            <span className={clsx(styles.errorLDActions)}></span>
            <h2>{field.name}</h2>
            {isConsolidation && dataReferenceMapping?.line_data_references[field.ref]?.data.organisation_short_code && (
              <span className={styles.orgCode}>
                {dataReferenceMapping?.line_data_references[field.ref]?.data.organisation_short_code}
              </span>
            )}
          </div>
          <div className={clsx(styles.rightSide)}>
            <Tooltip
              message={intl.formatMessage(
                {
                  id: 'reporting.map_value_or_delete_from_widget"',
                  defaultMessage: 'Map {target}, or delete from widget'
                },
                { target: getFieldType(field).toLocaleLowerCase() }
              )}
            >
              <button onClick={() => showFieldMapping(field.ref)}>
                <Icon type="edit" color="#cb374a" className={styles.editIcon} />
              </button>
            </Tooltip>
            <button
              onClick={() => onDelete(field.ref)}
              aria-label={intl.formatMessage({ id: 'common.delete', defaultMessage: 'Delete' })}
            >
              <Icon type="delete" className={styles.deleteIcon} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
